module.exports = __webpack_public_path__ + "static/IMG_7389-1500x1125-fe5a3d46ba7ee829fe701d973025c519.jpg";